import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Alert } from '@frontend/design-system';

export const ErrorFallback = () => {
  const { t } = useTranslation('insuranceEligibilityReport');

  return (
    <div css={{ margin: theme.spacing(5) }}>
      <Alert type='error'>
        {t(`We're unable to retrieve the eligibility report at this time. Please try and later.`)}
      </Alert>
    </div>
  );
};
